import { InjectionToken } from "@angular/core";
import { IAppVersionRestClient } from "./i-app-version-rest.client";

export const appVersionRestClientInjectionToken: InjectionToken<IAppVersionRestClient> = new InjectionToken<IAppVersionRestClient>( "digital-signage.developer-dashboard.dashboard-web.AppVersionRestClient" );
